import get from "lodash/get";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";

import List from "../../rows/list";
import { getLoadMoreStories } from "../../utils";
import TagFilter from "../../molecules/tag-filter";
import ScrollToTop from "../../atoms/back-to-top-button";

import "./tag-page.m.css";

const TagPage = (props) => {

  const [storiesToRender, setStoriesToRender] = useState(8);
  const [tagPageStories, setStories] = useState(props.data.stories);

  const tagName = get(props, ["data", "tags", "name"], "Tag Page");

  const dispatch = useDispatch();

  const setLoading = (isloading) => {
    dispatch(isloading ? { type: "QT-PAGE_LOADING" } : { type: "QT-PAGE_FINISHED_LOADING" });
  };

  const getMoreStories = async () => {
    setLoading(true);

    await getLoadMoreStories({
      offset: storiesToRender,
      limit: 4,
      slug: decodeURI(props.data.tags.slug),
      query: "tag-slugs",
      setStories: setStories,
      storiesToRender: storiesToRender,
      setStoriesToRender: setStoriesToRender,
      stories: tagPageStories,
    });

    setLoading(false);
  };

  return (
    <div className="container">
      <h2 styleName="tag-name" data-test-id="tag-name">
        {tagName}
      </h2>
      <TagFilter slug={decodeURI(props.data.tags.slug)} lang={props.data.lang} pageType="tag-page" />
      <List
        stories={tagPageStories.slice(0, storiesToRender)}
        showLoadmore={tagPageStories.length > storiesToRender}
        loadMoreStories={getMoreStories}
      />
      <ScrollToTop />
    </div>
  );
};

export { TagPage };

TagPage.propTypes = {
  data: PropTypes.object,
};
